import { Component, OnInit } from '@angular/core';

interface ItemData2 {
  name: string;
  age: string;
  address: string;
}

@Component({
  selector: 'app-employee-leave-entery',
  templateUrl: './employee-leave-entery.component.html',
  styleUrls: ['./employee-leave-entery.component.scss']
})
export class EmployeeLeaveEnteryComponent implements OnInit {

  value?: string;
  date = null;
  listOfData2: ItemData2[] = [];

  radioValue = 'A';

  onChange(result: Date): void {
    console.log('onChange: ', result);
  }

  constructor() { }

  ngOnInit(): void {
    for (let i = 0; i < 100; i++) {
      this.listOfData2.push({
        name: `${i}`,
        age: 'Kalubhai',
        address: 'General'
      });
    }
  }

}
